<div>
  <label *ngIf="label" [for]="id"
    >{{ label }} <app-dc-popover *ngIf="helpText" [body]="helpText" [class.helpText]="helpText"></app-dc-popover
  ></label>
  <div [class]="'input-group' + ' ' + (darkMode === true ? 'dark' : '')">
    <div class="input-group-prepend">
      <button class="btn btn-link calendar" (click)="canClickDateButton(d)" type="button">
        <img src="/assets/calendar.svg" alt="Date picker" />
      </button>
    </div>
    <input
      [placeholder]="placeholder"
      class="form-control dateInput"
      name="dp"
      [formControl]="control"
      ngbDatepicker
      #d="ngbDatepicker"
      [id]="id"
      readonly="true"
      [container]="container"
    />
  </div>
</div>
